/**
 * Validates a warranty field value.
 * Returns an error message string if invalid, or null if valid.
 * A value is invalid if it is 0 or negative.
 * Empty/null/undefined values are valid (optional field).
 */
export function getWarrantyError(value) {
  if (value === null || value === undefined || value === '') return null;
  const num = Number(value);
  if (isNaN(num) || num <= 0) return 'Warranty must be greater than 0';
  return null;
}

/**
 * Checks if any warranty field in an array of values has a validation error.
 * @param {Array} values - Array of warranty field values to check.
 * @returns {boolean} true if any value is invalid.
 */
export function hasWarrantyErrors(values) {
  return values.some((v) => getWarrantyError(v) !== null);
}
